import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { Button, createStyles, makeStyles, Tooltip } from "@material-ui/core";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import useCollapse from "react-collapsed";
import { useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ChipCmp from "../../../components/chip/chipCmp";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import {
  SALE_ITEM,
  TABLE_FILTER,
  TABLE_FILTER_REGISTER,
} from "../../../config/cacheKey";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../../models/common.model";
import { FilterFinder, PaginationInfo } from "../../../models/loan.model";
import {
  getSalesByCustomerSearchRequest,
  openSaleResponse,
  SaleSearchFilter,
} from "../../../models/supplier.model";
import {
  GetOpenSales,
  GetOpenSalesReportExcel,
} from "../../../services/supplier.service";

import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import AutocomplateCheckbox from "../../../components/autocomplete/AutocomplateCheckbox";
import PriceFeildComponent from "../../../components/priceFeild/priceFeildComponent";
import {
  IDropDownResponse,
  IGetBranchesRequest,
  IGetEnumsRequest,
  IResponse,
} from "../../../models/dropdown.model";
import { ISaleItemRequest } from "../../../models/sale.model";
import {
  GetBranchesAndStores,
  GetEnums,
  GetIBans,
} from "../../../services/dropdown.service";
import { convertToLocalDateTime } from "../../../utility/dateUtility";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src='images/Next.png' />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src='images/Previous.png' />
  );
};

const columns: readonly ColumnModel[] = [
  { id: "customerName", label: "متقاضی" },
  { id: "customerNationalCode", label: "کد ملی" },
  {
    id: "customerMobileNumber",
    label: "شماره همراه",
  },
  {
    id: "saleAmount",
    label: "مبلغ فاکتور (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
];
let muiSelected: any;
export default function OpenSalesTable() {
  const [jsonFile, setJsonFile] = useState<any>();
  let request = JSON.parse(
    localStorage.getItem(SALE_ITEM)!
  ) as ISaleItemRequest | null;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_SHELL_CONFIG}`)
      .then((response) => response.json())
      .then((data) => {
        setJsonFile(data);
      });
  }, []);
  muiSelected = jsonFile?.secondColor_100;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  const [valueFilterData, setValueFilterData] = React.useState<
    SaleSearchFilter
  >();

  const queryClient = useQueryClient();
  const history = useHistory<{
    from: string;
    id: number;
    pageNumber: number;
    clickOnBack: boolean;
    saleKey: string;
    branchId: number;
    customerPersonId: number;
  }>();

  const [isExpanded, setExpanded] = useState(true);
  const [data, setData] = useState<openSaleResponse[]>([]);
  const [valueCustomerNationalCode, setValueCustomerNationalCode] = useState<
    string
  >();
  const [valueCustomerName, setValueCustomerName] = useState<string>();
  const [valueCustomerMobileNumber, setValueCustomerMobileNumber] = useState<
    string
  >();
  const [valueSaleAmountFrom, setValueSaleAmountFrom] = useState<string>();
  const [valueSaleAmountTo, setValueSaleAmountTo] = useState<string>();
  const [valueBranchIds, setValueBranchIds] = useState<any[]>([]);
  const [valueBranchTitle, setValueBranchTitle] = useState<any[]>([]);

  const [valueIbans, setValueIbans] = useState<any[]>([]);
  const [valueSaleStatuses, setValueSaleStatuses] = useState<string[]>([]);
  const [valueSettlementDate, setValueSettlementDate] = useState<string>();
  const [valueSaleDate, setValueSaleDate] = useState<string>();
  const [settlementDate, setSettlementDate] = useState<
    Date[] | null | undefined
  >(null);
  const [saleDate, setSaleDate] = useState<Date[] | null | undefined>(null);

  const [selectedRow, setSelectedRow] = useState(undefined);

  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;

  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber =
        history.location.state != undefined
          ? history.location.state.pageNumber
          : 1;
      return paginationInfo;
    }
  );

  const [branchOption, setBranchOption] = React.useState<IDropDownResponse[]>(
    []
  );
  const [ibansOption, setIbansOption] = React.useState<IResponse[]>([]);
  const [saleStatusesOption, setSaleStatusesOption] = React.useState<
    IResponse[]
  >([]);
  const [valueTitleResponse, setValueTitleResponse] = useState<any[]>([]);
  const [inputVal, setInputVal] = useState<string>("");
  React.useEffect(() => {
    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<SaleSearchFilter>(TABLE_FILTER);
      if (filterData !== undefined && filterData !== null) {
        setValueCustomerName(filterData!.customerName!);
        setValueCustomerNationalCode(filterData!.customerName!);
        setValueCustomerMobileNumber(filterData!.customerMobileNumber!);
        setValueSaleAmountFrom(filterData!.saleAmountFrom!);
        setValueSaleAmountTo(filterData!.saleAmountTo!);
        setValueBranchIds(filterData!.branchStoreIds!);
        setValueIbans(filterData!.ibans!);
        setValueSaleStatuses(filterData?.saleStatuses!);
        setValueFilterData(filterData);
        setValueSaleDate("");
      }
    } else {
      filterData = new SaleSearchFilter();
      filterData.customerName = "";
      filterData.customerNationalCode = "";
      filterData.customerMobileNumber = "";
      filterData.saleAmountFrom = undefined;
      filterData.saleAmountTo = undefined;
      filterData.branchStoreIds = [];
      filterData.ibans = [];
      // filterData.requestDatePersian = "";
      queryClient.setQueryData(TABLE_FILTER, null);
      setValueFilterData(filterData);
    }
    fillData(filterData!);
    const getBranches = {} as IGetBranchesRequest;
    // getBranches.title = "";
    GetBranchesAndStoresMutate(getBranches);
    GetIbansMutate(getBranches);
    const enums = {} as IGetEnumsRequest;
    enums.enumNames = ["SaleStatus"];
    GetEnumsMutate(enums);
  }, []);
  const { mutateAsync: GetOpenSalesMutate } = useMutation(GetOpenSales, {
    onSuccess: (data: ApiResultModel<openSaleResponse[]>) => {
      setData(data.data!);
      setPageInfo(data.pageInfo);
    },
  });

  const { mutateAsync: GetOpenSalesReportExcelMutate } = useMutation(
    GetOpenSalesReportExcel,
    {
      onSuccess: (result) => {},
      onError: (e) => {},
    }
  );

  const { mutateAsync: GetBranchesAndStoresMutate } = useMutation(
    GetBranchesAndStores,
    {
      onSuccess: (data: IDropDownResponse[]) => {
        setBranchOption(data);
      },
    }
  );
  const { mutateAsync: GetIbansMutate } = useMutation(GetIBans, {
    onSuccess: (data: IResponse[]) => {
      setIbansOption(data);
    },
  });
  const { mutateAsync: GetEnumsMutate } = useMutation(GetEnums, {
    onSuccess: (data: IResponse[]) => {
      setSaleStatusesOption(data);
    },
  });

  const setChildValueCustomerName = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerName(selectedItem);
    const tabelFilter = queryClient.getQueryData<SaleSearchFilter>(
      TABLE_FILTER
    );
    if (tabelFilter != undefined) tabelFilter!.customerName = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueCustomerNationalCode = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerNationalCode(selectedItem);
    const tabelFilter = queryClient.getQueryData<SaleSearchFilter>(
      TABLE_FILTER
    );
    if (tabelFilter != undefined) tabelFilter!.customerNationalCode = undefined;
    fillData(tabelFilter!);
  };

  const setChildValueBranchIds = (childValues: any) => {
    let delValue = branchOption.filter(
      (item: any) => item.title === childValues
    );
    const updatedRenderOption = valueTitleResponse?.filter(
      (item: any) =>
        item.parentId !== delValue[0].parentId ||
        item.childId !== delValue[0].childId
    );
    setValueTitleResponse(updatedRenderOption);
    let titleValue = valueBranchTitle.filter(
      (item: any) => item !== childValues
    );
    setValueBranchTitle(titleValue);

    const selectedItem = valueBranchIds.filter(
      (item: any) =>
        item.parentId !== delValue[0].parentId ||
        item.childId !== delValue[0].childId
    );
    setValueBranchIds(selectedItem);
    const tabelFilter = queryClient.getQueryData<SaleSearchFilter>(
      TABLE_FILTER
    );
    if (tabelFilter !== undefined && tabelFilter !== null) {
      tabelFilter.branchStoreIds = tabelFilter!.branchStoreIds
        ?.filter(
          (item: any) =>
            item.parentId !== delValue[0].parentId ||
            item.childId !== delValue[0].childId
        )
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueIbans = (childValues: any) => {
    const selectedItem = valueIbans.filter((item: any) => item !== childValues);
    setValueIbans(selectedItem);
    const tabelFilter = queryClient.getQueryData<SaleSearchFilter>(
      TABLE_FILTER
    );
    if (tabelFilter !== undefined && tabelFilter !== null) {
      tabelFilter.ibans = tabelFilter!.ibans
        ?.filter((item: any) => item !== childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueSaleStatuses = (childValues: any) => {
    const selectedItem = valueSaleStatuses.filter(
      (item: any) => item !== childValues
    );
    setValueSaleStatuses(selectedItem);
    const tabelFilter = queryClient.getQueryData<SaleSearchFilter>(
      TABLE_FILTER
    );
    if (tabelFilter !== undefined && tabelFilter !== null) {
      tabelFilter.saleStatuses = tabelFilter!.saleStatuses
        ?.filter((item: any) => item !== childValues)
        .map((items: any) => {
          return items;
        });
    }
    fillData(tabelFilter!);
  };
  const setChildValueCustomerMobileNumber = (childValues: any) => {
    const selectedItem = "";
    setValueCustomerMobileNumber(selectedItem);
    const tabelFilter = queryClient.getQueryData<SaleSearchFilter>(
      TABLE_FILTER
    );
    if (tabelFilter != undefined) tabelFilter!.customerMobileNumber = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueSaleAmountFrom = (childValues: any) => {
    const selectedItem = "";
    setValueSaleAmountFrom(selectedItem);
    const tabelFilter = queryClient.getQueryData<SaleSearchFilter>(
      TABLE_FILTER
    );
    if (tabelFilter != undefined) tabelFilter!.saleAmountFrom = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueSaleAmountTo = (childValues: any) => {
    const selectedItem = "";
    setValueSaleAmountTo(selectedItem);
    const tabelFilter = queryClient.getQueryData<SaleSearchFilter>(
      TABLE_FILTER
    );
    if (tabelFilter != undefined) tabelFilter!.saleAmountTo = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueSettlementDate = (childValues: any) => {
    const selectedItem = "";
    setValueSettlementDate(selectedItem);
    setSettlementDate(undefined);
    const tabelFilter = queryClient.getQueryData<SaleSearchFilter>(
      TABLE_FILTER
    );
    if (tabelFilter != undefined) {
      tabelFilter!.settlementDateFrom = undefined;
      tabelFilter!.settlementDateTo = undefined;
      tabelFilter!.settlementDate = undefined;
    }

    fillData(tabelFilter!);
  };
  const setChildValueSaleDate = (childValues: any) => {
    const selectedItem = "";
    setValueSaleDate(selectedItem);
    setSaleDate(undefined);
    const tabelFilter = queryClient.getQueryData<SaleSearchFilter>(
      TABLE_FILTER
    );
    if (tabelFilter != undefined) {
      tabelFilter!.saleDateFrom = undefined;
      tabelFilter!.saleDateTo = undefined;
      tabelFilter!.saleDate = undefined;
    }

    fillData(tabelFilter!);
  };

  const generateFilter = (
    filterData: SaleSearchFilter
  ): getSalesByCustomerSearchRequest => {
    let request = new getSalesByCustomerSearchRequest();
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    return request;
  };

  const fillData = (filterData: SaleSearchFilter) => {
    let filter = generateFilter(filterData);
    GetOpenSalesMutate(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<SaleSearchFilter>(
      TABLE_FILTER
    );
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    changePageNumber(newPage + 1);
  };
  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
    handleSelectRow(undefined);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    alert("handleChangeRowsPerPage");
    // setRowsPerPage(+event.target.value);
    // setPage(0);
  };

  // const handleChangeMultiselect = (
  //   event: SelectChangeEvent<typeof loanRequestOptions>
  // ) => {
  //   const {
  //     target: { value },
  //   } = event;
  // };
  //aaded go to stepper
  const dispatch = useDispatch();

  const handleSelectRow = (rowIndex: any) => {
    const cachPageNumber = queryClient.getQueryData(
      TABLE_FILTER_REGISTER
    ) as FilterFinder;
    const filter = new FilterFinder();
    filter.rowNumber = rowIndex;
    setSelectedRow(rowIndex);
    queryClient.setQueryData(TABLE_FILTER_REGISTER, filter);
  };
  function handelCollapse() {
    setExpanded(!isExpanded);
  }

  function changeValueCustomerName(e: any) {
    setValueCustomerName(e.currentTarget.value);
  }
  function changeValueCustomerNationalCode(e: any) {
    setValueCustomerNationalCode(e.currentTarget.value);
  }

  function changeValueBranchIds(e: any) {
    setValueBranchTitle(e.map((item: any) => item.title));
    setValueBranchIds(
      e.map((item: any) => ({
        parentId: item.parentId,
        childId: item.childId,
      }))
    );
    setValueTitleResponse(e);
  }
  function changeValueIbans(e: any) {
    setValueIbans(e);
  }
  function changeValueCustomerMobileNumber(e: any) {
    setValueCustomerMobileNumber(e.currentTarget.value);
  }
  function changeValueSaleAmountFrom(e: any) {
    setValueSaleAmountFrom(e.currentTarget.value);
  }
  function changeValueSaleAmountTo(e: any) {
    setValueSaleAmountTo(e.currentTarget.value);
  }
  function changeValueSaleStatuses(e: any) {
    setValueSaleStatuses(e);
  }

  function changeValueSettlementDate(e: any) {
    setSettlementDate(e);
    setValueSettlementDate(e.toString().replace(/,/g, " - "));
  }
  function changeValueSaleDate(e: any) {
    setSaleDate(e);
    setValueSaleDate(e.toString().replace(/,/g, " - "));
  }
  function deleteChip() {
    setValueBranchIds([]);
    setValueIbans([]);
    setValueBranchTitle([]);
    setValueSaleStatuses([]);
    setValueTitleResponse([]);
    setValueCustomerName("");
    setValueCustomerMobileNumber("");
    setValueSaleAmountFrom(undefined);
    setValueSaleAmountTo(undefined);
    setValueCustomerNationalCode("");
    setValueSettlementDate("");
    setValueSaleDate("");
    queryClient.setQueryData(TABLE_FILTER, null);
    fillData(queryClient.getQueryData(TABLE_FILTER)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = new SaleSearchFilter();
  filter.branchStoreIds = [];
  filter.ibans = [];
  filter.saleStatuses = [];

  const handleClick = () => {
    console.info("You clicked the Chip.");
  };

  const handleDelete = () => {
    console.info("You clicked the delete icon.");
  };
  const handelDetail = (
    saleKey: string,
    customerPersonId: number,
    branchId: number,
    rowIndex: number
  ) => {
    handleSelectRow(rowIndex);

    history.push(`/sale/ProformaInvoice`);
    // history.push({
    //   pathname: "/sale/saleFactorFilesStep",
    //   state: {
    //     from: "",
    //     id: branchId,
    //     pageNumber: currentPaginationInfo.pageNumber!,
    //     clickOnBack: false,
    //     saleKey: saleKey,
    //     branchId: branchId,
    //     customerPersonId: customerPersonId,
    //   },
    // });

    const request = {} as ISaleItemRequest;
    request.saleKey = saleKey!;
    request.branchId = branchId!;
    request.customerPersonId = customerPersonId!;
    localStorage.setItem(SALE_ITEM, JSON.stringify(request));
  };
  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };

  let exportExcel = () => {
    GetOpenSalesReportExcelMutate(
      valueFilterData ? valueFilterData! : new SaleSearchFilter()
    );
  };
  const theme = createTheme({
    direction: "rtl", // Both here and <body dir="rtl">
  });
  // Create rtl cache
  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });
  return (
    <div>
      <Tooltip title='فیلتر' arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src='images/filter.png'
        />
      </Tooltip>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title='خروجی اکسل' arrow>
        <img
          onClick={exportExcel}
          className='cursorPointer'
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src='images/ExportXLS.svg'
        />
      </Tooltip>
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values: any) => {
              if (
                settlementDate != null &&
                (settlementDate[0] != undefined ||
                  settlementDate[1] != undefined)
              ) {
                values.settlementDateFrom = convertToLocalDateTime(
                  Number(settlementDate[0])
                );
                if (settlementDate.length > 1) {
                  values.settlementDateTo = convertToLocalDateTime(
                    Number(settlementDate[1])
                  );
                } else {
                  values.settlementDateTo = convertToLocalDateTime(
                    Number(settlementDate[0])
                  );
                }
              } else {
                values.settlementDateFrom = undefined;
                values.settlementDateTo = undefined;
                values.settlementDate = undefined;
              }
              if (
                saleDate != null &&
                (saleDate[0] != undefined || saleDate[1] != undefined)
              ) {
                values.saleDateFrom = convertToLocalDateTime(
                  Number(saleDate[0])
                );
                if (saleDate.length > 1) {
                  values.saleDateTo = convertToLocalDateTime(
                    Number(saleDate[1])
                  );
                } else {
                  values.saleDateTo = convertToLocalDateTime(
                    Number(saleDate[0])
                  );
                }
              } else {
                values.saleDateFrom = undefined;
                values.saleDateTo = undefined;
                values.saleDate = undefined;
              }
              // values.requestDatePersian = valueRequestDate;
              // values.requestDateArray = requestDate;

              queryClient.setQueryData(TABLE_FILTER, values);
              values.customerName = valueCustomerName;
              values.customerNationalCode = valueCustomerNationalCode;
              values.customerMobileNumber = valueCustomerMobileNumber;
              values.saleAmountFrom = Number(
                String(valueSaleAmountFrom).replace(/,/g, "")
              );
              values.saleAmountTo = Number(
                String(valueSaleAmountTo).replace(/,/g, "")
              );
              values.branchStoreIds = valueBranchIds;
              values.ibans = valueIbans;
              values.saleStatuses = valueSaleStatuses;
              values.settlementDate = valueSettlementDate;
              values.saleDate = valueSaleDate;
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
              // changePageNumber(1);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className='row'>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <MaterialTextFieldComponent
                      className='shadowTextField'
                      helperText={""}
                      placeHolder={"متقاضی"}
                      label={"متقاضی "}
                      required={false}
                      value={valueCustomerName}
                      onChange={changeValueCustomerName}
                      name='customerName'
                      id='customerName'
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <MaterialTextFieldComponent
                      className='shadowTextField'
                      helperText={""}
                      placeHolder={"کد ملی"}
                      label={"کد ملی "}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name='customerNationalCode'
                      id='customerNationalCode'
                      type='number'
                      inputProps={{ maxLength: 10 }}
                    />
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <MaterialTextFieldComponent
                      className='shadowTextField'
                      helperText={""}
                      placeHolder={"َشماره همراه"}
                      label={"َشماره همراه "}
                      required={false}
                      value={valueCustomerMobileNumber}
                      onChange={changeValueCustomerMobileNumber}
                      name='customerMobileNumber'
                      id='customerMobileNumber'
                      type='tel'
                      inputProps={{ maxLength: 11 }}
                    />
                  </div>
                  <CacheProvider value={cacheRtl}>
                    <ThemeProvider theme={theme}>
                      <div
                        className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                        style={{ paddingTop: "30px" }}
                      >
                        <AutocomplateCheckbox
                          label={"فروشنده / شعبه"}
                          value={valueBranchIds}
                          onChange={changeValueBranchIds}
                          changeMultiSelect={changeValueBranchIds}
                          name='customerBranchIds'
                          id='customerBranchIds'
                          options={branchOption}
                          responseValue={valueTitleResponse}
                          inputVal={inputVal}
                        />
                      </div>
                    </ThemeProvider>
                  </CacheProvider>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <PriceFeildComponent
                          placeHolder={" مبلغ فاکتور از (ریال)"}
                          label={" مبلغ فاکتور از (ریال) "}
                          required={true}
                          value={valueSaleAmountFrom ?? ""}
                          onChange={changeValueSaleAmountFrom}
                          name='saleAmountFrom'
                          id='saleAmountFrom'
                          // onBlur={handleBlur}
                          showPersianWords={false}
                        />
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12'
                    style={{ paddingTop: "30px" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <PriceFeildComponent
                          placeHolder={" مبلغ فاکتور تا (ریال)"}
                          label={" مبلغ فاکتور تا (ریال) "}
                          required={true}
                          value={valueSaleAmountTo ?? ""}
                          onChange={changeValueSaleAmountTo}
                          name='saleAmountTo'
                          id='saleAmountTo'
                          // onBlur={handleBlur}
                          showPersianWords={false}
                        />
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  {/* <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <MultiSelectChip
                      label={"وضعیت "}
                      value={valueSaleStatuses}
                      onChange={changeValueSaleStatuses}
                      changeMultiSelect={changeValueSaleStatuses}
                      name="saleStatuses"
                      id="saleStatuses"
                      options={saleStatusesOption}
                    />
                  </div> */}

                  <div
                    className='col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter'
                    style={{ paddingTop: "30px" }}
                  >
                    <Button
                      fullWidth
                      variant='contained'
                      type='submit'
                      className='btnForm SuccessDefault  '
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>

                {valueCustomerName ||
                valueCustomerNationalCode ||
                valueCustomerMobileNumber ||
                valueSaleAmountFrom ||
                valueSaleAmountTo ||
                valueBranchIds?.length ||
                valueIbans?.length ||
                valueSaleStatuses?.length ||
                valueSettlementDate ||
                valueSaleDate ? (
                  <div className='row tableCMP'>
                    <Grid container xs={12}>
                      <Grid item xs={12} sm={0.5} style={{ marginTop: "20px" }}>
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src='images/RemoveAllFilters.svg'
                          />
                        </Button>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={11.5}
                        style={{ marginTop: "10px" }}
                      >
                        <ChipCmp
                          item={valueCustomerName}
                          enamValue={valueCustomerName}
                          index={valueCustomerName?.length}
                          setChildValue={setChildValueCustomerName}
                        />
                        <ChipCmp
                          item={valueCustomerNationalCode}
                          enamValue={valueCustomerNationalCode}
                          index={valueCustomerNationalCode?.length}
                          setChildValue={setChildValueCustomerNationalCode}
                        />
                        <ChipCmp
                          item={valueCustomerMobileNumber}
                          enamValue={valueCustomerMobileNumber}
                          index={valueCustomerMobileNumber?.length}
                          setChildValue={setChildValueCustomerMobileNumber}
                        />
                        <ChipCmp
                          item={valueSaleAmountFrom}
                          enamValue={valueSaleAmountFrom}
                          index={valueSaleAmountFrom?.length}
                          setChildValue={setChildValueSaleAmountFrom}
                          isPrice
                        />
                        <ChipCmp
                          item={valueSaleAmountTo}
                          enamValue={valueSaleAmountTo}
                          index={valueSaleAmountTo?.length}
                          setChildValue={setChildValueSaleAmountTo}
                          isPrice
                        />

                        <ChipCmp
                          item={valueIbans}
                          enamValue={ibansOption}
                          index={valueIbans?.length}
                          setChildValue={setChildValueIbans}
                        />
                        {valueBranchTitle.map((title, index) => (
                          <ChipCmp
                            key={index}
                            item={title}
                            enamValue={title}
                            index={index}
                            setChildValue={setChildValueBranchIds}
                          />
                        ))}
                        <ChipCmp
                          item={valueSaleStatuses}
                          enamValue={saleStatusesOption}
                          index={valueSaleStatuses?.length}
                          setChildValue={setChildValueSaleStatuses}
                        />
                        <ChipCmp
                          item={valueSettlementDate}
                          enamValue={valueSettlementDate}
                          index={valueSettlementDate?.length}
                          setChildValue={setChildValueSettlementDate}
                        />
                        <ChipCmp
                          item={valueSaleDate}
                          enamValue={valueSaleDate}
                          index={valueSaleDate?.length}
                          setChildValue={setChildValueSaleDate}
                        />
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className='cardTableBorder '>
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          className={`${data?.length > 0 ? "boxScrollSubmit" : ""}`}
        >
          <Table
            stickyHeader
            aria-label='sticky table '
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className='rowTHead' style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
              >
                <TableCell
                  className='rowTHead colorTitle textFont12 fontWeight'
                  align='right'
                  style={{ width: "5px" }}
                >
                  ردیف
                </TableCell>
                {columns?.map((column) => (
                  <TableCell
                    className='rowTHead colorTitle textFont12 fontWeight nowrapClass'
                    key={column.id}
                    align='right'
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>

            <TableBody
              style={{
                height: "30px",
                minHeight: "30px",
              }}
            >
              {data?.map((row, rowIndex) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft cursorPointer noWrap`}
                    hover
                    role='checkbox'
                    tabIndex={-1}
                    // key={row.loanRequestId}
                    selected={selectedRow === rowIndex}
                    onClick={() =>
                      handelDetail(
                        row.saleKey,
                        row.customerPersonId,
                        row.branchId,
                        rowIndex
                      )
                    }
                  >
                    <TableCell className='textFont12' style={{ width: "5px" }}>
                      {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                        (currentPaginationInfo.pageSize! ?? 0) +
                        rowIndex +
                        1}
                    </TableCell>
                    {columns?.map((column) => {
                      const value = row[column.id as keyof openSaleResponse];
                      return (
                        <TableCell
                          className='textFont12 nowrapClass'
                          key={column.id}
                          align='right'
                        >
                          {column.format && column.hasFormat ? (
                            column.format(value)
                          ) : column.id === "saleStatusTitle" ? (
                            value === "در انتظار ثبت فاکتور" ? (
                              <b style={{ color: "#FB8C00" }}> {value}</b>
                            ) : value === "رد شده توسط ستاد" ? (
                              <b style={{ color: "#E6123D" }}> {value}</b>
                            ) : (
                              value
                            )
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems='center'>
          <Grid
            item
            xs={12}
            sm={4}
            display='flex'
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display='flex' justifyContent='center'>
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={
                pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
              }
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
    </div>
  );
}
